import { BlockType } from '@next-space/fe-api-idl';
import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Icon } from 'src/common/components/icon';
import { useCreateDocPage } from 'src/hooks/page';
import { useIsGuest } from 'src/hooks/share/use-permission-utils';
import { useCurrentSpace } from 'src/hooks/space';
import { bindDataTestId, TestIds } from 'src/utils/qa-utils';
import { TocType } from '../main/aside/toc/types';

export const PageDocEmpty = () => {
  const currentSpace = useCurrentSpace();
  const history = useHistory();
  const createPage = useCreateDocPage();
  const [isCreating, setCreating] = useState(false);
  const isGuest = useIsGuest();

  const handleClick = useCallback(async () => {
    if (isCreating) return;
    setCreating(true);
    try {
      const id = createPage(BlockType.PAGE, { parentId: currentSpace.uuid }, TocType.SPACE);
      history.push({
        pathname: `/${id}`,
      });
    } finally {
      setCreating(false);
    }
  }, [createPage, currentSpace.uuid, history, isCreating]);

  return (
    <div className="cursor-default login-wrapper space-y-2 text-t1-medium">
      <div className="text-h0">🎉 欢迎使用</div>
      {isGuest ? (
        <div>这是你的协作空间</div>
      ) : (
        <div
          className="flex items-center justify-center space-x-2 animate-click text-grey3"
          {...bindDataTestId(TestIds.emptyCreateDoc)}
          onClick={handleClick}
        >
          <Icon name="IcAdd" size="middle" />
          <span>创建新页面</span>
        </div>
      )}
    </div>
  );
};
